import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from '../../../core/services/local-storage.service';
import { StorageKeys } from '../../../core/constants/storage.constants';
import { AuthService } from '../../auth/services/auth.service';
import { catchError, map, of } from 'rxjs';
import { NgxSonnerToaster, toast } from 'ngx-sonner';
import { environment } from '../../../../environments/environment.dev';
import { LayoutService } from '../services/layout.service';

export const authGuard: CanActivateFn = (route, state) => {
  const localStorageService = inject(LocalStorageService);
  const authService = inject(AuthService);
  const router = inject(Router);
  const layoutService = inject(LayoutService);

  const token = localStorageService.get<string>(StorageKeys.AUTH_TOKEN);

  if (!token) {

    if ((environment as any).envName === 'prod') {
      router.navigate(['/home']);
    } else {
      router.navigate(['/home']);
    }
    return false;
  }

  return authService.currentUser().pipe(
    map(user => {
      if (user) {
        layoutService.setUserInfo(user);
        try {
          // authService.currentUserStats().subscribe(stats => {
          //   layoutService.setUserStats(stats);
          // });
        } catch (error) {
          toast.error('Failed to fetch user stats');
        }
        return true;
      } else {
        toast.error('Session expired. Please login again.');
        router.navigate(['/home']);
        return false;
      }
    }),
    catchError(() => {
      toast.error('Authentication Error. Please login again.');
      router.navigate(['/home']);
      return of(false);
    })
  );
};
